import React from 'react'

import { Portlet, Button, Table, Row, Col } from '_zari/core'

import NuevaPlacaModal from './modals/nuevo'
import EditarPlacaModal from './modals/editar'

const PlacasSection = ({ placas, dispatch }) => {
  const editarData = React.useRef({})

  const [mostrarNuevaPlacaModal, setMostrarNuevaPlacaModal] = React.useState(false)

  const [mostrarEditarPlacaModal, setMostrarEditarPlacaModal] = React.useState(false)

  const agregarPlacaHandler = payload => {
    dispatch({ type: 'agregar', payload })
    setMostrarNuevaPlacaModal(false)
  }

  const actualizarPlacaHandler = payload => {
    dispatch({ type: 'actualizar', payload })
    setMostrarEditarPlacaModal(false)
  }

  const clickEditarPlacaHandler = ({ _idFila }) => {
    const filas = placas.filter(row => row._idFila === _idFila)
    editarData.current = filas[0]
    setMostrarEditarPlacaModal(true)
  }

  const eliminarPlacaHandler = ({ _idFila }) => {
    dispatch({ type: 'eliminar', payload: { _idFila } })
  }

  return (
    <>
      <Portlet>
        <Portlet.Body noPadding>
          <Row>
            <Col md={12} className='mb-2 text-right'>
              <Button onClick={e => setMostrarNuevaPlacaModal(true)}>Nuevo</Button>
            </Col>
          </Row>
          <Table.ClientSide
            headRows={[{ label: 'PLACA' }, { label: '' }]}
            filas={placas}
            rowTemplate={row => (
              <Table.Row hover key={row._idFila}>
                <Table.Cell>{row.placa || '--'}</Table.Cell>
                <Table.Cell>
                  <Table.Dropdown>
                    {({ handleClose }) => [
                      <Table.Dropdown.Item
                        key='editar'
                        handleClose={handleClose}
                        onClick={e => clickEditarPlacaHandler({ _idFila: row._idFila })}
                      >
                        Editar
                      </Table.Dropdown.Item>,
                      <Table.Dropdown.Item
                        key='eliminar'
                        handleClose={handleClose}
                        onClick={e => eliminarPlacaHandler({ _idFila: row._idFila })}
                      >
                        Eliminar
                      </Table.Dropdown.Item>
                    ]}
                  </Table.Dropdown>
                </Table.Cell>
              </Table.Row>
            )}
          />
        </Portlet.Body>
      </Portlet>
      {mostrarNuevaPlacaModal && (
        <NuevaPlacaModal
          handleClose={e => setMostrarNuevaPlacaModal(false)}
          show={mostrarNuevaPlacaModal}
          agregarPlaca={agregarPlacaHandler}
        />
      )}
      {mostrarEditarPlacaModal && (
        <EditarPlacaModal
          modalData={editarData.current}
          handleClose={e => setMostrarEditarPlacaModal(false)}
          show={mostrarEditarPlacaModal}
          actualizarPlaca={actualizarPlacaHandler}
        />
      )}
    </>
  )
}

export default React.memo(PlacasSection)
